var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Admin Recommendations","fields":_vm.fields,"response":_vm.recommendations},on:{"delete":_vm.deleteRecommendation,"create":_vm.createSkill,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }